import detectEthereumProvider from '@metamask/detect-provider'
import store from "@/store"
import config from "@/config/index"
import auth from "@/lib/metamask/auth";

let ethereum = null

async function connectWallet() {
    await initEthereumProvider()
    await switchChain()

    const accounts = await ethereum.request({ method: 'eth_requestAccounts' })
    if (accounts.length === 0) {
        // MetaMask is locked or the user has not connected any accounts
        throw Error("Metamask not yet connected")
    }
    store.state.loggedInAccount = accounts[0]

    ethereum.on('chainChanged', handleChainChanged);
    ethereum.on('accountsChanged', handleAccountsChanged);
}

async function personalSign(msg) {
    try {
        const from = store.state.loggedInAccount;
        const hexMsg = `0x${Buffer.from(msg,'utf8').toString('hex')}`;
        const sign = await ethereum.request({
            method: 'personal_sign',
            params: [hexMsg, from],
        });
        return sign
    } catch (err) {
        console.log(err)
        throw Error("Fail to sign message with ethereum wallet")
    }
}

async function initEthereumProvider() {
    if (ethereum) {
        return
    }

    //initial metamask when ethereum object not exist
    const provider = await detectEthereumProvider();
    if (provider) {
        //initial listener
        if (provider !== window.ethereum) {
            throw Error("Multiple ethereum wallets detected!")
        }
        ethereum = window.ethereum
    } else {
        throw Error("Metamask not found!")
    }
}

async function switchChain() {
    try {
        await ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: config.blockchainConfig.chainId}],
        });
    } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
            try {
                await ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [
                        {
                            chainId: config.blockchainConfig.chainId,
                            chainName: config.blockchainConfig.chainName,
                            rpcUrls: [config.blockchainConfig.rpcUrl],
                            nativeCurrency: {
                                name: "MATIC",
                                symbol: "MATIC", // 2-6 characters long
                                decimals: 18,
                            },
                            blockExplorerUrls: [config.blockchainConfig.explorerUrl],
                        },
                    ],
                });
            } catch (addError) {
                console.error(addError.message)
                throw Error("Fail to add network to wallet")
            }
        }
        // handle other "switch" errors
    }
}

async function handleAccountsChanged(accounts) {
    console.log("Handle account changed, accounts: ", accounts)
    if (accounts.length === 0) {
        // MetaMask is locked or the user has not connected any accounts
        console.error("No account being connected")
    } else if (accounts[0] !== store.state.loggedInAccount) {
        if (store.state.loggedInAccount) {
            // logout when account switching
            await auth.logout()
            window.location.reload()
        }
    }
}

function handleChainChanged(chainId) {
    console.log("Handle chain changed, chainId: ", chainId)
    if (chainId !== config.blockchainConfig.chainId) {
        console.error("Connecting wrong network")
    }
}

export default {
    connectWallet,
    personalSign
}